import { Product } from "@/types/product";
import { memo } from "react";
import { getProductVariantData } from "@/utils/get-product-variant-data";

interface CartItemSmallProps {
  product: Product;
  onClick: (product: Product) => void;
}

const CartItemSmall = memo(function CartItemSmall({
  product,
  onClick,
}: CartItemSmallProps) {
  const { variantToShow, image, imageAlt, formattedPrice } =
    getProductVariantData(product);
  const handleClick = () => {
    onClick(product);
  };

  return (
    <button
      type="button"
      className="nut-flex nut-flex-col nut-gap-0 nut-h-full nut-w-full nut-cursor-pointer nut-text-left nut-rounded-[16px] nut-border nut-border-gray-200 nut-bg-white nut-p-[8px] nut-shadow-sm hover:nut-border-[#A99CF8]"
      onClick={handleClick}
      aria-label={`View ${product.title}`}
    >
      <div className="nut-relative nut-flex-shrink-0 nut-w-full nut-h-[132px] nut-rounded-[12px] nut-bg-gray-50 nut-overflow-hidden">
        <img
          src={image}
          alt={imageAlt}
          className="nut-w-full nut-h-full nut-object-contain nut-p-[6px]"
        />
        {variantToShow?.available_for_sale && (
          <span className="nut-absolute nut-top-[6px] nut-left-[6px] nut-bg-white/90 nut-text-[#228B5A] nut-text-[10px] nut-font-bold nut-rounded-full nut-px-[7px] nut-py-[3px]">
            In stock
          </span>
        )}
      </div>
      <div className="!sf-pro-display nut-mt-[7px] nut-flex nut-flex-col nut-h-full nut-gap-0">
        <p className="!sf-pro-display nut-font-bold nut-line-clamp-1 nut-mb-[7px] nut-text-[14px] [@media(max-width:768px)]:nut-text-[13px]">
          {product.title}
        </p>

        <div className="nut-justify-self-end nut-flex nut-items-center nut-gap-[6px]">
          <p className="!sf-pro-display nut-font-bold nut-text-[#797AFF] nut-text-[16px]">
            {formattedPrice || "N/A"}
          </p>
        </div>
      </div>
    </button>
  );
});

export default CartItemSmall;
